import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../api/axios';
import { BASE_URL } from '../constants/apiConstants';


interface initialState {
  params: any;
  sites: any[],
  dayparts: any[],
  previousPlan: boolean,
  productionData: any[],
  reportData: any[],
  cafewiseData: any[],
  loading: boolean,
  error: any,
}

const initialState: initialState = {
  params: null,
  sites: [],
  dayparts: [],
  previousPlan: false,
  productionData: [],
  reportData: [],
  cafewiseData: [],
  loading: false,
  error: null
};

export const fetchSites = createAsyncThunk(
  'productionPlan/fetchSites',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/Site/GetSitesByUserId`, payload);
    return response?.data?.data?.sites;
  }
);

export const fetchDayPartCode = createAsyncThunk(
  'productionPlan/fetchDayParts',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetDayPart`, payload);
    return response?.data?.data?.daypartlist;
  }
);

export const fetchProductionPlan = createAsyncThunk(
  'productionPlan/fetchProductionPlan',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ProductionPlan/GetProductionPlan`, payload);
    return response?.data?.data?.kitchensectionlist;
  }
);

export const fetchProductionPlanReport = createAsyncThunk(
  'productionPlan/fetchProductionPlanReport',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ProductionPlan/GetProductionPlanReport`, payload);
    return response?.data?.data;
  }
);

const productionPlanSlice = createSlice({
  name: 'productionPlan',
  initialState,
  reducers: {
    setProductionPlanParams(state, action) {
      state.params = action.payload;
    },
    setProductionPreviousPlan(state, action) {
      state.previousPlan = action.payload;
    },
    clearProductionState(state) {
        state.productionData = [],
        state.reportData = [],
        state.loading = false,
        state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSites.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSites.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.sites = payload;
      })
      .addCase(fetchSites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // daypart 
    builder
      .addCase(fetchDayPartCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDayPartCode.fulfilled, (state, action) => {
        state.loading = false;
        state.dayparts = action.payload;
      })
      .addCase(fetchDayPartCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // getProductionPlan
    builder
    .addCase(fetchProductionPlan.pending, (state) => {
      state.loading = true;
    })
    .addCase(fetchProductionPlan.fulfilled, (state, action) => {
      state.loading = false;
      state.productionData = action.payload;
    })
    .addCase(fetchProductionPlan.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    // getProductionPlanReport
    builder
    .addCase(fetchProductionPlanReport.pending, (state) => {
      state.loading = true;
    })
    .addCase(fetchProductionPlanReport.fulfilled, (state, action) => {
      state.loading = false;
      state.reportData = action.payload;
    })
    .addCase(fetchProductionPlanReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  }
});

export const { setProductionPlanParams, setProductionPreviousPlan, clearProductionState } = productionPlanSlice.actions;

export default productionPlanSlice.reducer;
